
<template>
  <img :src="getLogo"
       alt="Logo"
       class="img-fluid">
</template>

<script>
export default {
  name: 'Logo',
  computed: {
    getLogo() {
      return process.env.VUE_APP_LOGO_URL
    },
  },
}
</script>